import React from 'react';
import styled from 'styled-components';
import LayoutHeader from '../../layout/LayoutHeader';

const Wrap = styled.div`
  width: 100%;
  max-width: 390px;
  margin: 0 auto;
  padding: 24px 16px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
`;

/**
 * Legacy /manager route entrypoint.
 * On desktop, PrivateRoutes renders the desktop chat page inside DesktopLayout.
 * On mobile, chat is primarily accessed via the home experience.
 */
export default function ManagerApp() {
  return (
    <LayoutHeader>
      <Wrap>
        Chat is available on the home experience. On desktop, use the Chat tab in the top navigation.
      </Wrap>
    </LayoutHeader>
  );
}


